import { DefaultTheme, ThemeProps } from 'styled-components';
import { DesignToken } from '../types';
import { getToken } from './getToken';

export const SPACING_TOKENS = [
    '0',
    '25',
    '50',
    '100',
    '150',
    '200',
    '250',
    '300',
    '400',
    '450',
    '500',
    '600',
    '700',
    '800',
    '900',
    '1000',
    '1200',
] as const;
type SpacingTokens = typeof SPACING_TOKENS;
export type SpacingToken = SpacingTokens[number];

export const getSpacingToken =
    (spacing: SpacingToken) =>
    ({ theme }: ThemeProps<DefaultTheme>) => {
        const token: DesignToken = `spacing${spacing}`;

        return getToken(token)({ theme });
    };
